export enum AmericanFootballPassAttribute {
  PassIncomplete = 703,
  PassComplete = 704,
}
